import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { InViewportModule } from 'ng-in-viewport';
import { SpinnersModule } from '../spinners/spinners.module';

import { PaginationComponent } from './pagination.component';

@NgModule({
  declarations: [PaginationComponent],
  imports: [LocaleSharedModule, CommonModule, SpinnersModule, InViewportModule],
  exports: [PaginationComponent],
})
export class PaginationModule {}
